module.exports = __webpack_public_path__ + "static/media/menu_1_20260724.4cd24231.webp";